import useAnalyticsContext from '@client/hooks/useAnalyticsContext';
import AnalyticsConstants from '@constants/analytics';
import { useSourcePage } from '@hooks/use-source-page';
import { useCallback } from 'react';
import type { CategoryCode } from 'types/Category';
import { ESTIMATE_REQUEST_FLOW_SOURCE_CONTENT } from './trackingConstants';

export const useTrackCrossCategoryLinkClick = () => {
	const { track } = useAnalyticsContext();
	const sourcePage = useSourcePage();

	return useCallback(
		(vendorCategoryCode: CategoryCode) => {
			track({
				event: AnalyticsConstants.CLICK_THROUGH_TO_VENDOR_CATEGORY,
				properties: {
					sourcePage,
					sourceContent: ESTIMATE_REQUEST_FLOW_SOURCE_CONTENT,
					vendorCategoryCode,
				},
			});
		},
		[track, sourcePage],
	);
};
